// Style constants for OrganizeTab component

// Room Card Styles
export const ROOM_CARD_BASE = "transition-all border-l-4";
export const ROOM_CARD_INSURER_BORDER = "border-l-slate-300 dark:border-l-slate-700";
export const ROOM_CARD_CONTRACTOR_BORDER = "border-l-blue-300 dark:border-l-blue-700";
export const ROOM_CARD_HIGHLIGHTED = "ring-2 ring-primary ring-offset-2";
export const ROOM_CARD_LOCKED = "opacity-60 bg-slate-50 dark:bg-slate-900/50";
export const ROOM_CARD_INVALID_TARGET = "opacity-30";

// Line Item Styles
export const LINE_ITEM_BASE = "group flex items-center gap-3 p-2 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors text-sm";
export const LINE_ITEM_SELECTED = "bg-blue-50 dark:bg-blue-900/10";
export const LINE_ITEM_DRAGGING = "opacity-50";
export const LINE_ITEM_LOCKED = "opacity-60 bg-slate-100/50 dark:bg-slate-900/50";

// Chevron Styles
export const CHEVRON_BASE = "h-4 w-4 transition-transform";
export const CHEVRON_OPEN = "rotate-90";
